<template>
  <apartment-modal
    :form_fields="get_form_fields"
    :modal_title="isEdit ? $t('objects.edit_home') : $t('objects.add_home')"
    :ok_title="isEdit ? $t('generals.save') : $t('generals.create')"
    :def_form_obj="defObj"
    @formSubmit="saveApartment"
  />
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import apartmentModal from "../../../../../components/validatedFormModal.vue";

export default {
  components: {
    apartmentModal,
  },
  props: {
    isEdit: {
      type: Boolean,
      required: false,
      default: false,
    },
    defObj: {
      type: Object,
      required: false,
      default() {
        return {};
      },
    },
  },
  computed: {
    ...mapGetters("objects", ["GET_OBJECTS"]),
    ...mapGetters("knowledgeBase", [
      "GET_APARTMENT_MATERIALS",
      "GET_PREMISES_DECORATIONS",
      "GET_CONSTRUCTION_STAGES",
      "GET_QUARTERS",
      "GET_MONTHS",
      "GET_APARTMENT_TYPES",
      "GET_CONSTRUCTION_TYPES",
    ]),
    get_form_fields() {
      return [
        {
          component_name: "b-form-input",
          col_size: 6,
          obj_name: "title",
          validation_rules: "required",
          label: `${this.$t("objects.home_name")}:`,
          placeholder: this.$t("objects.home_name"),
        },
        {
          component_name: "v-select",
          col_size: 6,
          obj_name: "rc_object",
          validation_rules: "required",
          label: `${this.$t("objects.residential_complex")}:`,
          placeholder: this.$t("objects.residential_complex"),
          props: {
            label: "title",
            options: this.GET_OBJECTS,
            reduce: (option) => option.id,
          },
        },
        {
          component_name: "v-select",
          col_size: 6,
          obj_name: "construction_type",
          label: `${this.$t("objects.building_type")}:`,
          placeholder: this.$t("objects.building_type"),
          props: {
            getOptionLabel: (option) => option.title[this.$i18n.locale],
            reduce: (option) => option.id,
            options: this.GET_CONSTRUCTION_TYPES,
            multiple: true,
          },
        },
        {
          component_name: "v-select",
          col_size: 6,
          obj_name: "apartment_type",
          label: `${this.$t("objects.type_of_premises")}:`,
          placeholder: this.$t("objects.type_of_premises"),
          props: {
            getOptionLabel: (option) => option.title[this.$i18n.locale],
            reduce: (option) => option.id,
            options: this.GET_APARTMENT_TYPES,
          },
        },
        {
          col_size: 6,
          obj_name: "street",
          label: `${this.$t("objects.street")}:`,
          placeholder: this.$t("objects.street"),
        },
        {
          col_size: 6,
          obj_name: "number",
          label: `${this.$t("objects.number_house")}:`,
          placeholder: this.$t("objects.number_house"),
        },
        {
          obj_name: "premises_decoration",
          col_size: 6,
          label: `${this.$t("objects.facade_finishing")}:`,
          placeholder: this.$t("objects.facade_finishing"),
          props: {
            getOptionLabel: (option) => option.title[this.$i18n.locale],
            options: this.GET_PREMISES_DECORATIONS,
            reduce: (option) => option.id,
          },
        },
        {
          component_name: "v-select",
          obj_name: "home_material",
          col_size: 6,
          label: `${this.$t("objects.home_material")}:`,
          placeholder: this.$t("objects.home_material"),
          props: {
            getOptionLabel: (option) => option.title[this.$i18n.locale],
            options: this.GET_APARTMENT_MATERIALS,
            reduce: (option) => option.id,
          },
        },
        {
          component_name: "v-select",
          obj_name: "construction_stage",
          label: `${this.$t("objects.construction_stage")}:`,
          placeholder: this.$t("objects.construction_stage"),
          props: {
            options: this.GET_CONSTRUCTION_STAGES,
            getOptionLabel: (option) => option.title[this.$i18n.locale],
            reduce: (option) => option.id,
          },
        },
        {
          component_name: "date-picker",
          col_size: 6,
          obj_name: "construction_start_date",
          label: `${this.$t("objects.construction_start_date")}:`,
          placeholder: this.$t("objects.construction_start_date"),
          // props: {
          //   config: {
          //     altInput: true,
          //     allowInput: true,
          //     altFormat: 'd.m.Y',
          //     dateFormat: 'Y-m-d',
          //     locale: Russian,
          //   },
          // },
        },
        {
          component_name: "date-picker",
          col_size: 6,
          obj_name: "construction_end_date",
          label: `${this.$t("objects.construction_end_date")}:`,
          placeholder: this.$t("objects.construction_end_date"),
        },
        {
          component_name: "date-picker",
          col_size: 6,
          obj_name: "sale_start_date",
          label: `${this.$t("objects.sale_start_date")}:`,
          placeholder: this.$t("objects.sale_start_date"),
        },
        {
          component_name: "date-picker",
          col_size: 6,
          obj_name: "sale_end_date",
          label: `${this.$t("objects.sale_end_date")}:`,
          placeholder: this.$t("objects.sale_end_date"),
        },
        {
          obj_name: "cadastral_number",
          label: `${this.$t("objects.cadastral_number")}:`,
          col_size: 6,
          placeholder: this.$t("objects.cadastral_number"),
        },
        {
          obj_name: "issued_by",
          label: `${this.$t("objects.issued_by")}:`,
          col_size: 6,
          placeholder: this.$t("objects.issued_by"),
        },
        {
          label: `${this.$t("objects.document")}:`,
          obj_name: "file",
          component_name: "b-form-file",
          placeholder: this.$t("objects.no_file_selected"),
          props: {
            "browse-text": this.$t("objects.select"),
            accept: ".pdf",
          },
        },
        {
          label: `${this.$t("Ипотечный")}:`,
          obj_name: "is_mortgage",
          component_name: "b-form-checkbox",
          switch: true,
        },
      ];
    },
  },
  created() {
    this.FETCH_OBJECTS();
    this.FETCH_APARTMENT_MATERIALS();
    this.FETCH_PREMISES_DECORATIONS();
    this.FETCH_CONSTRUCTION_STAGES();
    this.FETCH_CONTRUCTION_TYPES();
    this.FETCH_MONTHS({ page_size: 12 });
    // this.FETCH_QUARTERS()
    this.FETCH_APARTMENT_TYPES();
  },
  methods: {
    ...mapActions("objects", ["FETCH_OBJECTS"]),
    ...mapActions("apartments", ["ADD_APARTMENT", "EDIT_APARTMENT"]),
    ...mapActions("knowledgeBase", [
      "FETCH_APARTMENT_MATERIALS",
      "FETCH_PREMISES_DECORATIONS",
      "FETCH_CONSTRUCTION_STAGES",
      "FETCH_MONTHS",
      "FETCH_QUARTERS",
      "FETCH_APARTMENT_TYPES",
      "FETCH_CONTRUCTION_TYPES",
    ]),
    saveApartment(apartment) {
      const { is_mortgage, ...rest } = apartment;

      const data = {
        is_mortgage: JSON.stringify(is_mortgage),
        ...rest,
      };
      const fd = this.$_objectToFormData(data);
      if (typeof apartment.file === "string") {
        fd.delete("file");
      }
      if (this.isEdit) {
        this.EDIT_APARTMENT(fd).then(() => {
          this.$nextTick(() => {
            this.$bvModal.hide("validated-form-modal");
          });
          this.$emit("save");
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$t("generals.changed"),
              icon: "CheckSquareIcon",
              variant: "success",
              timeout: 1000,
            },
          }).catch(() => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: this.$t("generals.error"),
                icon: "CheckSquareIcon",
                variant: "danger",
                timeout: 1000,
              },
            });
          });
        });
      } else {
        this.ADD_APARTMENT(fd)
          .then(() => {
            this.$nextTick(() => {
              this.$bvModal.hide("validated-form-modal");
            });
            this.$emit("save");
            this.$toast({
              component: ToastificationContent,
              props: {
                title: this.$t("generals.added"),
                icon: "CheckSquareIcon",
                variant: "success",
                timeout: 1000,
              },
            });
          })
          .catch(() => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: this.$t("generals.error"),
                icon: "CheckSquareIcon",
                variant: "danger",
                timeout: 1000,
              },
            });
          });
      }
    },
  },
};
</script>

<style></style>
